/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Assistant_Toggle_HistoryInputs */



/**
* | output |
* | --- |
* | "Toggle chat history" |
*
* @param {Assistant_Toggle_HistoryInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const assistant_toggle_history = /** @type {((inputs?: Assistant_Toggle_HistoryInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Assistant_Toggle_HistoryInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Afficher/masquer l'historique des conversations")
	if (locale === "de") return /** @type {LocalizedString} */ ("Chatverlauf ein-/ausblenden")
	if (locale === "it") return /** @type {LocalizedString} */ ("Attiva/disattiva la cronologia della chat")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Отключить историю чата")
	if (locale === "es") return /** @type {LocalizedString} */ ("Mostrar/ocultar historial de chat")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("切换聊天记录")
	if (locale === "ja") return /** @type {LocalizedString} */ ("チャット履歴の切り替え")
	if (locale === "hi") return /** @type {LocalizedString} */ ("चैट इतिहास को टॉगल करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Alternar histórico de bate-papo")
	return /** @type {LocalizedString} */ ("Toggle chat history")
});